import { type ReactNode } from 'react'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'

export interface DependentProfilesDialogProps {
  /**
   * The list of dependents to render.
   */
  children?: ReactNode
  /**
   * Whether the dialog is open.
   */
  isOpen: boolean
  /**
   * Callback when the dialog should close.
   */
  onClose?: () => unknown
  /**
   * Whether the dependents list is empty.
   */
  isEmpty?: boolean
  /**
   * Test ID attribute.
   */
  testId?: string
  /**
   * Test ID attribute for the close button.
   */
  closeTestId?: string
}

/**
 * The DependentProfilesDialog
 */
export function DependentProfilesDialog({
  isOpen,
  onClose,
  children,
  isEmpty,
  testId,
  closeTestId,
}: DependentProfilesDialogProps) {
  return (
    <ModalDialog
      isDismissable
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      sheetSizing="stretch"
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>Your dependents</ModalDialogTitle>
        {isEmpty ? (
          <ModalDialogDescription>
            Claim dependents on your taxes to increase your refund.
          </ModalDialogDescription>
        ) : (
          <ModalDialogDescription>
            Review your dependents' details, or add more dependents below.
          </ModalDialogDescription>
        )}
      </ModalDialogHeader>
      <ModalDialogContent>{children}</ModalDialogContent>
      <ModalDialogFooter>
        <ModalDialogActions>
          <Button
            variant="outline"
            label="Close"
            onPress={onClose}
            testId={closeTestId}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
}
